import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { SUPPORT_EMAIL } from "../constants/data";

export default function PrivacyPolicy() {
  return (
    <Page>
      <Shell>
        <BackLink to="/">Back to home</BackLink>
        <Card>
          <Eyebrow>Privacy Policy</Eyebrow>
          <Title>How IPTV Time handles your information.</Title>
          <Updated>
            Last updated: <strong>October 21, 2021</strong>
          </Updated>

          <Section>
            <SectionTitle>1. Information We Collect</SectionTitle>
            <Paragraph>
              IPTV Time is designed to help you manage playlists and program
              reminders without building a business around personal data. We do
              not sell user information and we do not share personal data with
              third parties for advertising.
            </Paragraph>
            <Paragraph>
              The app only uses the information required to provide the core
              experience, such as playlist content, channel metadata, reminder
              settings, and iCloud synchronization when enabled on your device.
            </Paragraph>
          </Section>

          <Section>
            <SectionTitle>2. Changes to This Privacy Policy</SectionTitle>
            <Paragraph>
              This policy may be updated from time to time. Any changes become
              effective once the updated policy is published on this page and,
              when relevant, communicated inside the app.
            </Paragraph>
          </Section>

          <Section>
            <SectionTitle>3. Contact</SectionTitle>
            <Paragraph>
              If you have questions or suggestions about this privacy policy,
              contact{" "}
              <ContactLink href={`mailto:${SUPPORT_EMAIL}`}>
                {SUPPORT_EMAIL}
              </ContactLink>
              .
            </Paragraph>
          </Section>
        </Card>
      </Shell>
    </Page>
  );
}

const Page = styled.main`
  padding: 32px 20px 60px;
`;

const Shell = styled.div`
  max-width: 900px;
  margin: 0 auto;
`;

const BackLink = styled(Link)`
  display: inline-flex;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.95rem;
`;

const Card = styled.article`
  padding: 32px;
  border-radius: 30px;
  background: ${({ theme }) => theme.colors.cardSurface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.colors.shadow};

  @media only screen and (max-width: ${({ theme }) => theme.mobileBreakpoint}) {
    padding: 24px;
  }
`;

const Eyebrow = styled.div`
  color: ${({ theme }) => theme.colors.accentDark};
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const Title = styled.h1`
  margin: 14px 0 10px;
  font-size: clamp(2.2rem, 5vw, 3.8rem);
  line-height: 1.02;
  letter-spacing: -0.05em;
`;

const Updated = styled.p`
  margin: 0 0 24px;
  color: ${({ theme }) => theme.colors.muted};
`;

const Section = styled.section`
  padding-top: 14px;
  border-top: 1px solid ${({ theme }) => theme.colors.border};

  & + & {
    margin-top: 18px;
  }
`;

const SectionTitle = styled.h2`
  margin: 0 0 10px;
  font-size: 1.3rem;
`;

const Paragraph = styled.p`
  margin: 0 0 14px;
  color: ${({ theme }) => theme.colors.ink};
  line-height: 1.75;
`;

const ContactLink = styled.a`
  color: ${({ theme }) => theme.colors.accentDark};
  font-weight: 700;
`;
